/**
 * TanStack Query hooks for `first-click-attribution`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	firstClickAttributionQueryKeys,
	type CreateFirstClickAttributionBody,
	type ListFirstClickAttributionResponse,
	type FirstClickAttributionRow,
} from "./api";

export function useFirstClickAttributionList(): UseQueryResult<ListFirstClickAttributionResponse, Error> {
	return useQuery({
		queryKey: firstClickAttributionQueryKeys.list(),
		queryFn: list,
	});
}

export function useFirstClickAttributionCreate(): UseMutationResult<FirstClickAttributionRow, Error, CreateFirstClickAttributionBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: firstClickAttributionQueryKeys.all });
		},
	});
}

export function useFirstClickAttributionDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: firstClickAttributionQueryKeys.all });
		},
	});
}
